module.exports = __webpack_public_path__ + "static/media/rc3.52f30168.jpg";